import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList";
import PencilIcon from "vue-material-design-icons/Pencil";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Message",
    children: [
      /* {
        icon: "view-list",
        title: "List Message",
        to: { name: "message.list", query: { limit: 10, filter: "all" } },
        loggedIn: true,
      }, */
      {
        icon: "view-list",
        title: "List Conversation",
        to: {
          name: "conversation.list",
          query: {
            limit: 10,
            filter: "mine",
            sort: "created_date",
            order: "desc",
          },
        },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Message",
        to: { name: "message.create" },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
  // {
  //   name: "Conversation",
  //   children: [
  //     {
  //       icon: "view-list",
  //       title: "List Conversation",
  //       to: { name: "conversation.list", query: { limit: 10, filter: "all" } },
  //       loggedIn: true,
  //     },
  //     /* {
  //       icon: "pencil",
  //       title: "New Conversation",
  //       to: { name: "conversation.create" },
  //       loggedIn: true,
  //     }, */
  //   ],
  //   loggedIn: true,
  // },
  /* {
    name: "Conversation Member",
    children: [
      {
        icon: "view-list",
        title: "List Conversation Member",
        to: {
          name: "conversation_member.list",
          query: { limit: 10, filter: "all" },
        },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Conversation Member",
        to: { name: "conversation_member.create" },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  }, */
  {
    name: "Manage",
    children: [],
    loggedIn: true,
  },
];
